import { fetchRetryParameters, requestHostHeaders } from '~/composables/constants/api'
import type { RequestHostHeadersType } from '~/composables/constants/api'
import type { CategoryItem, UnparsedCategoryItem } from '~/types/searchTypes'

export default async (queryKey: string, locale: string): Promise<CategoryItem[]> => {
  return await $fetch<{
    items: UnparsedCategoryItem[]
  }>('/api/search/parsed-categories', {
    method: 'POST',
    body: {
      queryKey,
      locale,
    },
    ...fetchRetryParameters,
    ...(typeof window !== 'undefined' && {
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    }),
  })
}
